export default {
  ORDER_AHEAD: 'orderAhead',
  PAY_AT_TABLE: 'payAtTable',
  ORDER_AT_TABLE: 'orderAtTable'
};
